import React from 'react';
import { Box, Flex } from '@chakra-ui/react';
import { useTranslation } from 'react-i18next';

import { useBannerSize } from '../../../../common/hooks/use-banner-size';
import { BannerDivider, EnergyUsedCell } from './banner-cells';
import { COLOR_NUMBER } from './banner-colors';

type ErrorBannerContentProps = {
  energy?: string;
};

export function ErrorBannerContent({ energy = '0.0' }: ErrorBannerContentProps) {
  const { h, fontSize } = useBannerSize();
  const { t } = useTranslation();
  return (
    <Flex align="center" w="100%" h={h}>
      <Box flex={1} textAlign="center" fontSize="12px">
        <Box fontSize={fontSize} letterSpacing="wider" color={COLOR_NUMBER} _dark={{ color: 'white' }}>
          {t('EVSE.stopped')}
        </Box>
        {t('Common.session')}
      </Box>
      <BannerDivider />
      <EnergyUsedCell energy={energy} />
    </Flex>
  );
}
